<template>
  <div class="project item">
    <div class="container custom">
      <div class="project__content single">
        <div class="project__content-breadcrumb" data-aos="fade">
          <el-breadcrumb separator="/">
            <template v-for="(item, index) in routeList">
              <el-breadcrumb-item v-if="item.meta.title" :key="index" :to="{ name: item.name }">
                {{ item.meta.title }}
              </el-breadcrumb-item>
            </template>
          </el-breadcrumb>
        </div>
        <div class="project__content-title" data-aos="fade-up">TimeStore</div>
        <div class="project__content-subtitle" data-aos="fade-up">Cashless sale solution by applying Blockchain technology</div>
        <div class="project__content-text" data-aos="fade-up">TimeBird store is an e-commercial application on both web and mobile platform. Employees can use an internal stable coin to pay for foods or beverage that listed on the menu of the store. Moreover, it’s easy to transfer/make withdrawal/ deposit for other purposes such as wedding lucky money, gift for new born baby. To ensure transparency, all transaction history is recorded on the TimeBird-owned blockchain network. Everyone can check it on Explorer application easily.</div>
      </div>
      <div class="project__slide" data-aos="fade" data-aos-delay="500">
        <swiper :options="slideOption" class="project__slide-list">
          <swiper-slide class="list__item">
            <img src="/assets/images/project/timestore-01.png" alt="">
          </swiper-slide>
          <swiper-slide class="list__item">
            <img src="/assets/images/project/timestore-02.png" alt="">
          </swiper-slide>
          <swiper-slide class="list__item">
            <img src="/assets/images/project/timestore-03.png" alt="">
          </swiper-slide>
          <div slot="pagination" class="swiper-pagination"></div>
        </swiper>
        <div class="project__slide-card" data-aos="fade" data-aos-delay="500" ref="scrollToMe">
          <div class="card__title">Download App TimeBird Store</div>
          <div class="card__list">
            <div class="card__list-item">
              <a href="https://play.google.com/store/apps/details?id=com.timebird.timestore&hl=vi&gl=US" target="_blank" class="item__link">
                <img src="/assets/images/project/google-play.png" alt="google-play">
              </a>
              <a href="https://apps.apple.com/vn/app/timebird-store/id1560290118?l=vi" target="_blank" class="item__link">
                <img src="/assets/images/project/app-store.png" alt="app-store">
              </a>
            </div>
            <div class="card__list-item">
              <div class="item__qr">
                <img src="/assets/images/project/timestore-qr.png" alt="qr">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="project__feature">
        <div class="project__feature-title" data-aos="fade-up">TimeStore’s features</div>
        <div class="project__feature-box">
          <div class="box__content">
            <template v-for="(item, index) in listFeature">
              <div class="box__content-list" data-aos="fade-right" :key="index">
                <div class="list__title">
                  <div class="icon">
                    <img src="/assets/images/layouts/icon-star.png" alt="icon">
                  </div>
                  {{ item.title }}
                </div>
                <template v-for="(_item, index) in item.listFeatureItem">
                  <div class="list__item" :key="index">
                    <div class="icon">
                      <img src="/assets/images/layouts/icon-bookmark.png" alt="icon">
                    </div>
                    {{ _item.title }}
                  </div>
                </template>
              </div>
            </template>
          </div>
          <div class="box__image" data-aos="fade-left">
            <img src="/assets/images/project/feature-image.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="project__guide">
      <div class="container custom">
        <div class="project__guide-title" data-aos="fade-up">How to use TimeStore</div>
        <div class="project__guide-subtitle" data-aos="fade-up">For end-user</div>
        <div class="project__guide-step" data-aos="fade" data-aos-delay="500">
          <el-steps :active="active">
            <el-step></el-step>
            <el-step></el-step>
          </el-steps>
          <div class="step__progress">
            <div class="step__progress-item download" :class="{ active: active === 0 }">
              <img src="/assets/images/project/icon-download.svg" alt="icon">
            </div>
            <div class="step__progress-item deposit" :class="{ active: active === 1 }">
              <img src="/assets/images/project/icon-deposit.svg" alt="icon">
            </div>
            <div class="step__progress-item purchase" :class="{ active: active === 2 }">
              <img src="/assets/images/project/icon-purchase.svg" alt="icon">
            </div>
          </div>
          <template v-if="active === 0">
            <div class="step__item">
              <div class="step__item-title">Step 1</div>
              <div class="step__item-content">Download <a href="javascript:;" @click.prevent="scrollToElement" class="link">TimeBird Store</a> on CH Play/ App Store</div>
            </div>
          </template>
          <template v-if="active === 1">
            <div class="step__item">
              <div class="step__item-title">Step 2</div>
              <div class="step__item-content">Make deposit request to get stable coin (pay through mobile money)</div>
            </div>
          </template>
          <template v-if="active === 2">
            <div class="step__item">
              <div class="step__item-title">Step 3</div>
              <div class="step__item-content">Purchase products by stable coin</div>
            </div>
          </template>
        </div>
        <div class="project__guide-button" data-aos="fade">
          <el-button @click="prev" class="button__prev" :class="{ active: active > 0 }">
            <img src="/assets/images/project/icon-chevron.svg" alt="icon">
          </el-button>
          <el-button @click="next" class="button__next" :class="{ active: active < 2 }">
            <img src="/assets/images/project/icon-chevron.svg" alt="icon">
          </el-button>
        </div>
        <div class="project__guide-subtitle" data-aos="fade-up">For enterprise</div>
        <div class="project__guide-text" data-aos="fade-up"><router-link :to="{ name: 'Contact' }" class="link">Contact TimeBird</router-link> to modify app as your needs</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      active: 0,
      listFeature: [
        { title: 'Admin app - web app', listFeatureItem: [
          { title: 'Mange sale activities such as import, inventory' },
          { title: 'Make various report such as revenue report, inventory' },
          { title: 'Create sale campaign' },
          { title: 'Track order step by step' },
        ]},
        { title: 'Customer app - mobile app', listFeatureItem: [
          { title: 'Make order by scanning QR code or selecting products from menu' },
          { title: 'Offer 2 options as self-serving or shipping' },
          { title: 'Able to do payment/withdrawal/top-up/transfer by stable coin' },
        ]},
        { title: 'Wallet admin app - mobile app', listFeatureItem: [
          { title: 'Track wallet balance of each user' },
          { title: 'Do transfer or approve withdrawal request automatically' },
          { title: 'Manage transaction history' },
        ]},
      ],
      slideOption: {
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slideToClickedSlide: true,
        speed: 800,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: -20,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
          scale: 0.8
        },
        breakpoints: {
          480: {
            slidesPerView: 2
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  computed: {
    routeList () {
      return this.$route.matched
    }
  },
  methods: {
    next() {
      if (this.active++ > 1) this.active = 2;
    },
    prev() {
      if (this.active-- < 1) this.active = 0;
    },
    scrollToElement() {
      const el = this.$refs.scrollToMe
      if (el) {
        el.scrollIntoView({behavior: 'smooth'})
      }
    },
  },
  created() {
    setTimeout(() => {
      AOS.refreshHard()
    }, 100) 
  }
}
</script>